import React from "react";

import { COLUMN_DATA } from "./constants";

const TableHeader = () => (
  <div className="flex justify-around border-b bg-white dark:bg-cs-ui-gray-800 p-3">
    {COLUMN_DATA.map(column => (
      <div
        className={`${column.className} text-gray-500 dark:text-shade-light`}
        key={column.title}
      >
        {column.title}
      </div>
    ))}
  </div>
);

export default TableHeader;
